// extracted by mini-css-extract-plugin
export default {"ThreeJsBackground":"ThreeJsBackground_ThreeJsBackground__-8UF-"};